var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1337_51123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6593 2.21746L4.74982 9.12646C4.70336 9.1731 4.64815 9.2101 4.58736 9.23535C4.52657 9.2606 4.46139 9.2736 4.39557 9.2736C4.32974 9.2736 4.26456 9.2606 4.20377 9.23535C4.14298 9.2101 4.08777 9.1731 4.04132 9.12646L1.36932 6.45196C1.32286 6.40532 1.26765 6.36831 1.20686 6.34306C1.14607 6.31781 1.08089 6.30481 1.01507 6.30481C0.94924 6.30481 0.884061 6.31781 0.823269 6.34306C0.762478 6.36831 0.707271 6.40532 0.660816 6.45196C0.614178 6.49841 0.577172 6.55362 0.551921 6.61441C0.52667 6.6752 0.513672 6.74038 0.513672 6.80621C0.513672 6.87203 0.52667 6.93721 0.551921 6.998C0.577172 7.05879 0.614178 7.114 0.660816 7.16046L3.33382 9.83296C3.61579 10.1144 3.99792 10.2725 4.39632 10.2725C4.79472 10.2725 5.17684 10.1144 5.45882 9.83296L12.3678 2.92546C12.4144 2.87901 12.4513 2.82384 12.4765 2.76309C12.5017 2.70235 12.5147 2.63722 12.5147 2.57146C12.5147 2.50569 12.5017 2.44057 12.4765 2.37982C12.4513 2.31908 12.4144 2.2639 12.3678 2.21746C12.3214 2.17082 12.2662 2.13381 12.2054 2.10856C12.1446 2.08331 12.0794 2.07031 12.0136 2.07031C11.9477 2.07031 11.8826 2.08331 11.8218 2.10856C11.761 2.13381 11.7058 2.17082 11.6593 2.21746Z",
    fill: "#725ED4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1337_51123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/Checkmark.293a04bb10a20d584429127f02d3d09f.svg";
export { ForwardRef as ReactComponent };